import theme from '@ilg-totallymoney/ui/theme'

const StarSvg = ({
    starColor = theme.warmYellow100,
    size = 12,
}: {
    size?: number
    starColor?: string
}) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 12 12"
    >
        <path
            fill={starColor}
            d="M2.4 11.9a.51.51 0 0 1-.2-.33c-.02-.14 0-.31.07-.5l.97-3.78L.41 5.1a1.07 1.07 0 0 1-.35-.36.49.49 0 0 1-.03-.4.5.5 0 0 1 .25-.28c.13-.07.3-.1.5-.1l3.33.03L5.4.6c.06-.2.14-.35.24-.45.1-.1.22-.15.36-.15.14 0 .26.05.35.15.1.1.19.25.25.45l1.3 3.38 3.32-.03c.2 0 .37.03.5.1a.5.5 0 0 1 .25.29c.05.13.04.26-.03.39-.06.12-.18.25-.35.36L8.96 7.3l.98 3.78a1 1 0 0 1 .06.5.5.5 0 0 1-.2.33c-.11.09-.24.12-.38.09s-.3-.1-.46-.22L6 9.56l-2.76 2.21c-.17.12-.32.2-.46.22a.44.44 0 0 1-.38-.09Z"
        />
    </svg>
)

export default StarSvg
